module.exports = __webpack_public_path__ + "img/bittermelon-350x184.e5cf7e5b.jpg";